import { MutableRefObject } from 'react';

import { Checkbox } from '@thefarmersfront/kitchen';

import { useShallow } from 'zustand/react/shallow';

import { ModalSection } from '~/components/common';

import { useStockReleaseStore } from '~/store';

import { DEFAULT_INPUT_STATUS } from '~/constants';

import { TypeStockReleaseRegisterErrorFieldRefs } from '~/types/stock.types';

import styles from './StockReleaseRegisterSecondStepContent.module.scss';

/**
 * [재고관리 > 반출요청관리] 반출요청등록 모달 > STEP 2 > 동의 사항
 */
const StockReleaseRegisterAgreeInfo = ({
  errorFieldRefs,
}: {
  errorFieldRefs: MutableRefObject<TypeStockReleaseRegisterErrorFieldRefs>;
}) => {
  const { agreeInfo, agreeInfoState, setAgreeInfo, setRegisterInfoState } = useStockReleaseStore(
    useShallow((state) => ({
      agreeInfo: state.agreeInfo,
      agreeInfoState: state.agreeInfoState,
      setAgreeInfo: state.actions.setAgreeInfo,
      setRegisterInfoState: state.actions.setRegisterInfoState,
    }))
  );

  return (
    <ModalSection className={styles['agree-info']} title="동의 사항">
      <div className={styles['checkbox-container']}>
        <Checkbox
          ref={(el) => (errorFieldRefs.current['agreeInfo.isCheckedPacking'] = el)}
          size="medium"
          label="(필수) 최종 반출되는 파렛트/박스 여부 및 수량은 패킹 결과에 따라 달라질 수 있습니다."
          checked={!!agreeInfo?.isCheckedPacking}
          status={agreeInfoState?.isCheckedPacking?.status}
          validationMessage={agreeInfoState?.isCheckedPacking?.message}
          onChange={(e) => {
            setAgreeInfo({ isCheckedPacking: e.target.checked });
            setRegisterInfoState({ agreeInfoState: { isCheckedPacking: DEFAULT_INPUT_STATUS } });
          }}
        />
        <Checkbox
          ref={(el) => (errorFieldRefs.current['agreeInfo.isCheckedDate'] = el)}
          size="medium"
          label="(필수) 실제 반출일은 현장 운영 상황에 따라 반출 희망일과 달라질 수 있습니다."
          checked={!!agreeInfo?.isCheckedDate}
          status={agreeInfoState?.isCheckedDate?.status}
          validationMessage={agreeInfoState?.isCheckedDate?.message}
          onChange={(e) => {
            setAgreeInfo({ isCheckedDate: e.target.checked });
            setRegisterInfoState({ agreeInfoState: { isCheckedDate: DEFAULT_INPUT_STATUS } });
          }}
        />
      </div>
    </ModalSection>
  );
};

export default StockReleaseRegisterAgreeInfo;
